import { Injectable } from '@angular/core';
import { wait } from 'src/app/core/util';
import { UserSettingsService } from 'src/app/core/services';

@Injectable({
  providedIn: 'root',
})
export class AppExtensionsService {
  isRunningInApp: boolean = false;

  lastAdShown: Date = new Date();
  readonly adInterval = 1000 * 90;

  constructor(private userSettingsService: UserSettingsService) {}

  public init() {
    this.isRunningInApp =
      (window as any).isRunningInAndroidApp ||
      (window as any).isRunningIniOSApp;
  }

  public async rumble(ms: number = 500): Promise<void> {
    const settings = this.userSettingsService.currentSettings;
    if (!settings.vibrationEnabled) return;

    if (navigator.vibrate) navigator.vibrate(ms);
    else this.call(`rumble://${ms}`);
  }

  public async getUUID(): Promise<string | undefined> {
    this.call(`get-uuid://`);
    await wait(200);
    return (window as any).uuid || undefined;
  }

  public reset(): void {
    this.call(`reset://`);
  }

  public showLoading(): void {
    this.call(`spinneron://`);
  }

  public hideLoading(): void {
    this.call(`spinneroff://`);
  }

  public maybeShowAd(): boolean {
    const settings = this.userSettingsService.currentSettings;
    if (settings.hasActivePremiumSubscription) return false;

    if (Date.now() - this.lastAdShown.getTime() < this.adInterval) return false;

    console.log('showing ad');

    this.call(`admob://`);
    this.lastAdShown = new Date();

    return true;
  }

  private call(url: string): void {
    if (!this.isRunningInApp) return;
    top.location.href = url;
  }
}
